import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Image from "../../../components/AppImage";

const ServiceCard = ({ service, index }) => {
  const [isHovered, setIsHovered] = useState(false);

  const themeClasses = {
    events: "bg-gradient-to-br from-rose-50 to-amber-50 border-rose-200",
    realestate: "bg-gradient-to-br from-slate-50 to-blue-50 border-slate-200",
    marketing: "bg-gradient-to-br from-orange-50 to-red-50 border-orange-200",
    design: "bg-gradient-to-br from-emerald-50 to-teal-50 border-emerald-200",
  };

  const accentColors = {
    events: "text-rose-600",
    realestate: "text-slate-600",
    marketing: "text-orange-600",
    design: "text-emerald-600",
  };

  const iconColors = {
    events: "bg-rose-100 text-rose-600",
    realestate: "bg-slate-100 text-slate-600",
    marketing: "bg-orange-100 text-orange-600",
    design: "bg-emerald-100 text-emerald-600",
  };

  return (
    <div
      className={`relative group rounded-2xl border-2 p-8 transition-all duration-500 hover:shadow-xl hover:-translate-y-2 ${
        themeClasses?.[service?.category]
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Service Icon */}
      <div
        className={`inline-flex items-center justify-center w-16 h-16 rounded-xl mb-6 ${
          iconColors?.[service?.category]
        }`}
      >
        <Icon name={service?.icon} size={28} />
      </div>
      {/* Service Title */}
      <h3 className="text-2xl font-bold text-primary mb-4 font-display">
        {service?.title}
      </h3>
      {/* Service Description */}
      <p className="text-muted-foreground mb-6 leading-relaxed">
        {service?.description}
      </p>
      {/* Key Features */}
      <div className="space-y-3 mb-8">
        {service?.features?.map((feature, idx) => (
          <div key={idx} className="flex items-center space-x-3">
            <div
              className={`w-2 h-2 rounded-full ${accentColors?.[
                service?.category
              ]?.replace("text-", "bg-")}`}
            ></div>
            <span className="text-sm text-foreground font-medium">
              {feature}
            </span>
          </div>
        ))}
      </div>
      {/* Sample Work Preview */}
      <div className="relative mb-6 overflow-hidden rounded-lg">
        <Image
          src={service?.sampleImage}
          alt={`${service?.title} sample work`}
          className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-4 left-4 right-4">
            <p className="text-white text-sm font-medium">
              {service?.sampleTitle}
            </p>
          </div>
        </div>
      </div>
      {/* Pricing Preview */}
      <div className="flex items-center justify-between mb-6 p-4 bg-white/50 rounded-lg">
        <div>
          <p className="text-sm text-muted-foreground">Starting from</p>
          <p
            className={`text-xl font-bold ${accentColors?.[service?.category]}`}
          >
            {service?.startingPrice}
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">Typical project</p>
          <p className="text-sm font-semibold text-foreground">
            {service?.typicalDuration}
          </p>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          size="sm"
          className={`flex-1 ${
            service?.category === "events"
              ? "bg-rose-600 hover:bg-rose-700"
              : service?.category === "realestate"
              ? "bg-slate-600 hover:bg-slate-700"
              : service?.category === "marketing"
              ? "bg-orange-600 hover:bg-orange-700"
              : "bg-emerald-600 hover:bg-emerald-700"
          } text-white`}
          iconName="MessageCircle"
          iconPosition="left"
        >
          Get Quote
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="flex-1"
          iconName="Eye"
          iconPosition="left"
        >
          View Portfolio
        </Button>
      </div>
      {/* Hover Indicator */}
      <div
        className={`absolute top-4 right-4 w-3 h-3 rounded-full transition-all duration-300 ${
          isHovered
            ? accentColors?.[service?.category]?.replace("text-", "bg-")
            : "bg-muted"
        }`}
      ></div>
    </div>
  );
};

export default ServiceCard;
